import React from 'react'
import { Typography } from '@material-ui/core'

interface Props {}

export const Loading: React.FC<Props> = ({}) => <Typography>Loading...</Typography>
